import { Fragment, type FC, type PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  sections: [
    <Fragment key={`copy-section-1`}>
      We recognize that learning Segment can be a bit daunting if you don’t already have a fully-functioning website or
      application source to connect.
    </Fragment>,
    <Fragment key={`copy-section-2`}>…But what if you did?</Fragment>,
    <Fragment key={`copy-section-3`}>
      We’ve partnered with Wilco to create a fully interactive experience where you learn to use Segment in a very
      realistic fashion: by actually implementing it in an example application! This isn’t a tour or a simulation—you’ll
      use an actual (free) Segment workspace and Wilco’s unique, fun “quest” structure to walk through an implementation
      of Segment events in a website. In this quest, you’ll use GitHub pull requests to make changes to a real
      application and make data travel from the website, to Segment, to a destination application. The skills you gain
      are directly transferable to your production implementation!
    </Fragment>,
    <Fragment key={`copy-section-4`}>
      …and while you’re there, check out the other educational offerings by Wilco. They have a growing library of quests
      where you can learn to use specific tools and skillsets. <strong>Never stop learning!</strong>
    </Fragment>,
  ],
  cta: `Get started`,
  href: `https://app.wilco.gg/company/Twilio/Segment/play`,
}

const Encouragement: FC<PropsWithChildren> = () => {
  return (
    <StyledSectionBase variant="centered">
      <StyledSectionContents>
        {copy.sections.map((text) => (
          <Typography key={text.key} variant="pMedium">
            {text}
          </Typography>
        ))}
        <ButtonWrapper>
          <Button href={copy.href} target="_blank" variant="filled" color="primary" size="large">
            {copy.cta}
          </Button>
        </ButtonWrapper>
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
  }
`
const StyledSectionContents = styled(Section.Contents)`
  max-width: 844px;
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 42px;
`

export default Encouragement
